var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0C30.165 0 38 7.83502 38 17.5C38 27.165 30.165 35 20.5 35C10.835 35 3 27.165 3 17.5C3 7.83502 10.835 0 20.5 0ZM20.4229 21.3643C15.1729 21.3643 10.7432 22.2227 10.7432 25.5352C10.7433 28.8462 15.2015 29.6738 20.4229 29.6738C25.6726 29.6738 30.1025 28.8159 30.1025 25.5049C30.1025 22.1925 25.644 21.3643 20.4229 21.3643ZM20.4229 5.32617C16.8679 5.32617 14.0166 8.1906 14.0166 11.7676C14.0167 15.3431 16.868 18.21 20.4229 18.21C23.9775 18.2097 26.828 15.3429 26.8281 11.7676C26.8281 8.19075 23.9776 5.32641 20.4229 5.32617Z",
    fill: "#5D7285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.87a5e1f77b2fab55ae2c455de487dd21.svg";
export { ForwardRef as ReactComponent };